// ColorOutput.tsx
// Output panel component displaying transformed color palette with copy functionality

import React from 'react';
import { PaletteStructure } from './types';

interface ColorOutputProps {
  paletteStructure: PaletteStructure;
  onEditInput: () => void;
}

export const ColorOutput: React.FC<ColorOutputProps> = ({ paletteStructure, onEditInput }) => {
  const handleCopyToClipboard = () => {
    const paletteString = `export const colors = {\n${Object.entries(paletteStructure.colors)
      .map(([key, value]) => `  ${key}: '${value}',`)
      .join('\n')}\n};`;
    navigator.clipboard.writeText(paletteString);
    alert('Palette copied to clipboard!');
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-bold">Transformed Palette</h2>
        <button
          onClick={onEditInput}
          className="px-4 py-2 bg-gray-700 hover:bg-gray-600 rounded text-sm"
        >
          Edit Input
        </button>
      </div>
      
      <p className="text-sm text-gray-400 mb-4">
        Drag the sphere to transform your palette.
      </p>
      
      {paletteStructure.groups.map((group, index) => (
        <div key={index} className="mb-6">
          <h3 className="text-lg font-semibold mb-2 text-blue-400">
            {group.title}
          </h3>
          <div className="space-y-2">
            {group.colors.map(colorKey => (
              <div key={colorKey} className="flex items-center space-x-2">
                <span className="text-xs w-32 text-gray-300">
                  {colorKey}:
                </span>
                <code className="flex-1 px-2 py-1 bg-gray-700 rounded text-xs font-mono">
                  {paletteStructure.colors[colorKey]}
                </code>
                <div 
                  className="w-8 h-8 rounded border border-gray-600"
                  style={{ 
                    backgroundColor: paletteStructure.colors[colorKey].includes('rgba') 
                      ? 'transparent' 
                      : paletteStructure.colors[colorKey] 
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      ))}
      
      <button
        onClick={handleCopyToClipboard}
        className="w-full py-3 bg-green-600 hover:bg-green-700 rounded-lg font-semibold transition-colors"
      >
        Copy Palette to Clipboard
      </button>
    </div>
  );
};